import { convertInlineMarkdown } from "src/components/TiptapDocumentSB/markdownStreamer";

function escapeHtml(value) {
  return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

// Models emit light Markdown (scene headings, **bold**, *italic*). The takeover
// renders it for rating; the copy the writer keeps must be converted the same
// way a normal Draft insertion is — one block per paragraph break, headings as
// headings, inline marks converted — or the manuscript receives the raw markup
// they just rated. Returns the shape `insertEditor` accepts: it prefers `html`
// and falls back to `text`.
export function renderKeptProse(text) {
  const source = typeof text === "string" ? text : "";
  const html = source
    .split(/\n+/)
    .map((block) => block.trim())
    .filter((block) => block && !/^(-{3,}|\*{3,}|_{3,})$/.test(block))
    .map((block) => {
      const converted = convertInlineMarkdown(escapeHtml(block));
      return /^<h[1-6]>/.test(converted) ? converted : `<p>${converted}</p>`;
    })
    .join("");
  return { text: source, html: html || undefined };
}
